import { LoadingButton } from "./loadingButton";
export function initializeEmailChange() {
    document.whenHtmlElementExists("confirmChangeEmailBtn", "success-message", "errorMessage", "changeEmailOverview", (confirmButton, successMessage, errorMessage, welcomeMessage) => {
        confirmButton.addEventListener("click", async (event) => {
            const notificationLoadingButton = LoadingButton.getOrCreateInstance(confirmButton);
            notificationLoadingButton.start();
            // Reset messages
            errorMessage.bootstrapHide();
            successMessage.bootstrapHide();
            const token = window.location.pathname.split("/").pop();
            try {
                const result = await fetch(`/Subscription/VerifyChangeEmail/${token}`, {
                    method: "POST",
                });
                if (result.status === 200) {
                    confirmButton.bootstrapHide();
                    successMessage.bootstrapShow();
                }
                else {
                    const errorMessageText = document.getHtmlElementById("errorMessageText");
                    if (errorMessageText) {
                        const errorJson = await result.json();
                        let errorString = "";
                        if (errorJson && typeof errorJson.result === "string") {
                            errorString = errorJson.result;
                        }
                        errorMessage.bootstrapShow();
                        errorMessageText.innerHTML = errorString;
                    }
                }
            }
            catch (error) {
                const errorMessageText = document.getRequiredHtmlElementById("errorMessageText");
                errorMessageText.innerHTML = `Error during opt-out: ${error instanceof Error ? error.message : "Unknown error"}`;
                errorMessage.bootstrapShow();
            }
            finally {
                confirmButton.bootstrapHide();
                welcomeMessage.bootstrapHide();
            }
        });
    });
}
